const features = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '极速追踪',
    desc: '7×24小时不间断监控全网热点，从微博热搜到抖音热门，大瓜发生的第一时间即为您推送，绝不让你错过任何一个名场面。',
  },
  {
    id: 2,
    icon: 'ri-shield-check-line',
    title: '多方求证',
    desc: '每条爆料经过专业编辑团队交叉验证，结合多个信息源进行真实性评估，力求还原事件真相，拒绝断章取义和恶意造谣。',
  },
  {
    id: 3,
    icon: 'ri-stack-line',
    title: '全面聚合',
    desc: '整合微博、小红书、抖音、豆瓣等多个平台的热议内容，一个网站看遍全网观点，吃瓜再也不用在十几个App之间来回切换。',
  },
  {
    id: 4,
    icon: 'ri-user-voice-line',
    title: '瓜友社区',
    desc: '汇聚百万吃瓜群众，评论区畅所欲言。每一条爆料都可以发表你的看法，和志同道合的瓜友一起讨论最新娱乐圈动态。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 text-accent-600 text-sm font-medium mb-3">
            <i className="ri-star-line"></i>
            平台特色
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            为什么瓜友都选爆瓜网
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            我们不只是搬运爆料，更致力于为吃瓜群众打造最专业、最全面的娱乐八卦资讯体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="group bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-default"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${feature.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading font-bold text-foreground-900 text-lg mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}